<template>
  <v-app id="inspire">
    <v-app-bar app dense hide-on-scroll clipped-left>
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      <v-toolbar-title>
        {{ phrase.title_finance_park }}
      </v-toolbar-title>
      <!-- <v-btn class="mr-4" rounded @click="debug" v-if="this.$store.state.is_debug == true">Auto Select</v-btn> -->
    </v-app-bar>
    <v-navigation-drawer app v-model="drawer" clipped temporary> <!--左ペイン-->
      <v-container>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title grey--text text--darken-2" style="white-space: pre-line">
              {{ phrase.title_finance_park_br }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list> <!--dense navもあり-->
          <v-list-item v-for="nav_list in nav_lists" :key="nav_list.link" v-scroll-to="{element:nav_list.link}">
            <v-list-item-icon>
              <v-icon>{{ nav_list.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ nav_list.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-container>
    </v-navigation-drawer>
    <div id='capture'>
      <v-main> <!--右ペイン-->
        <v-container fluid class="grey lighten-2 overflow-y-auto">
          <v-row>
            <v-col ref="personaTopCol" class="mt-2" cols="12" sm="12" md="4" lg="4"><personaCard /></v-col>
            <v-col class="mt-2 d-flex" cols="12" sm="12" md="8" lg="8"><barchartCard :forceHeight="personaCardHeight" /></v-col>
          </v-row>
          <v-row><house /></v-row>
          <v-row id="infra">
            <v-col class="mt-2" cols="12" sm="12" md="4" lg="4"><electricity /></v-col>
            <v-col class="mt-2" cols="12" sm="12" md="4" lg="4"><gas /></v-col>
            <v-col class="mt-2" cols="12" sm="12" md="4" lg="4"><water /></v-col>
          </v-row>
          <v-row><food /></v-row>
          <v-row><fashion /></v-row>
          <v-row><car /></v-row>
          <v-row><smartphone /></v-row>
          <v-row><media /></v-row>
          <v-row><dailyNecessities /></v-row>
          <v-row><stock2 /></v-row>
          <v-row><medical /></v-row>
          <v-row><saving /></v-row>
          <v-row><lifeInsurance /></v-row>
          <v-row><eatOut /></v-row>
          <v-row><lesson /></v-row>
          <v-row><emergencyKit /></v-row>
          <v-row><trip /></v-row>
          <v-row><stock3 /></v-row>
          <v-row>
            <v-col class="mt-2" cols="6" sm="6" md="4" lg="4">
              <v-btn class="mr-4" :disabled="dialog" @click="dialog_attention = true;" rounded x-large>{{ phrase.button_submit }}</v-btn>
            </v-col>
          </v-row>
          <v-dialog v-model="dialog_attention" persistent width="90vw" max-width="480">
            <v-card cols="3" sm="3" md="2" lg="2" width="90vw" max-width="480">
              <v-card-title class="text-h5 grey lighten-2">{{ phrase.title_submit }}</v-card-title>
              <v-card-text style="white-space: pre-line">
                <div class="my-5 text--primary">{{ phrase.help_submit }}</div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="justify-start">
                <v-btn color="primary" text @click="dialog_attention = false">
                  {{ phrase.dialog_back }}
                </v-btn>
                <v-btn color="primary" text @click="submit">
                  {{ phrase.button_submit }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog" persistent width="800">
            <v-card cols="3" sm="3" md="2" lg="2" width="800" max-width="800">
              <v-card-title class="text-h5 grey lighten-2">{{ phrase.title_submitting }}</v-card-title>
              <v-card-text style="white-space: pre-line">
                <br>
                <v-progress-linear :active="communication" :indeterminate="communication" color="orange" class="mb-0"></v-progress-linear>
                <div class="my-5 text--primary">{{ this.error_message }}</div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="justify-start">
                <v-btn color="primary" text :disabled="communication" @click="close_dialog">
                  {{ phrase.dialog_close }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <br>
        </v-container>
      </v-main>
    </div>
    <personalSheet ref="personalSheet" v-if="$store.state.target === 'ja'" />
    <v-footer app height=40 class="pb-2">
      <v-row align-content="center">
        <v-col align="center">
          <v-progress-linear color="orange" v-model="calc_progress_per" :buffer-value="100" height=16>
            {{ this.$store.state.progress }} / {{ this.$store.state.contents }}
          </v-progress-linear>
          ©Junior Achievement Japan All rights reserved.
          <div class="pb-2"></div>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { validatePersonalSheet, hasPersonalSheetErrors } from '../utils/personal-sheet-validation'
import words from '../assets/words.json'
import personalSheet from '../components/personal-sheet.vue';
import { personalSheetSubmission } from '../utils/personal-sheet';
import personaCard from '../components/persona-card.vue';
import barchartCard from '../components/barchart-card.vue';
import house from '../components/house.vue';
import electricity from '../components/electricity.vue';
import gas from '../components/gas.vue';
import water from '../components/water.vue';
import food from '../components/food.vue';
import fashion from '../components/fashion.vue';
import car from '../components/car.vue';
import smartphone from '../components/smartphone.vue';
import media from '../components/media.vue';
import dailyNecessities from '../components/daily-necessities.vue';
import stock2 from '../components/stock2.vue';
import medical from '../components/medical.vue';
import saving from '../components/saving.vue';
import lifeInsurance from '../components/life-insurance.vue';
import eatOut from '../components/eat-out.vue';
import lesson from '../components/lesson.vue';
import emergencyKit from '../components/emergency-kit.vue';
import trip from '../components/trip.vue';
import stock3 from '../components/stock3.vue';
import axios from 'axios';
import { buildFinanceSummary } from '../utils/finance-summary';

const API_ENDPOINTS = {
  DEV: {
    submit: 'https://vcl4ti4hra.execute-api.ap-northeast-1.amazonaws.com/submit'
  },
  PRD: {
    submit: 'https://to8butpz6e.execute-api.ap-northeast-1.amazonaws.com/submit'
  }
};
// import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return{
      drawer: null,
      nav_items:[
        { titleKey: 'persona_card_title', fallback: 'ペルソナ', icon: 'mdi-account', link: '#persona' },
        { titleKey: 'title_house', fallback: '住宅費(家賃・ローン)', icon: 'mdi-home', link: '#house' },
        { titleKeys: ['title_electricity', 'title_gas', 'title_water'], fallback: '光熱水費', icon: 'mdi-cards-heart', link: '#infra' },
        { titleKey: 'title_food', fallback: '食費', icon: 'mdi-rice', link: '#food' },
        { titleKey: 'title_fashion', fallback: '被服費', icon: 'mdi-hanger', link: '#fashion' },
        { titleKey: 'title_car', fallback: '自動車(月々支払い)', icon: 'mdi-car', link: '#car' },
        { titleKey: 'title_smartphone', fallback: '電話料金', icon: 'mdi-cellphone', link: '#smartphone' },
        { titleKey: 'title_media', fallback: '情報通信メディア', icon: 'mdi-newspaper-variant-outline', link: '#media' },
        { titleKey: 'title_daily_necessities', fallback: '日用品', icon: 'mdi-paper-roll', link: '#daily_necessities' },
        { titleKey: 'title_stock2', fallback: '株式 中間値', icon: 'mdi-chart-line', link: '#stock2' },
        { titleKey: 'title_medical', fallback: '医療(医薬品・健康診断)', icon: 'mdi-pill', link: '#medical' },
        { titleKey: 'title_saving', fallback: '貯蓄', icon: 'mdi-cash-fast', link: '#saving' },
        { titleKey: 'title_life_insurance', fallback: '生命保険', icon: 'mdi-lifebuoy', link: '#life_insurance' },
        { titleKey: 'title_eat_out', fallback: '外食', icon: 'mdi-silverware', link: '#eat_out' },
        { titleKey: 'title_lesson', fallback: '習い事(大人・子ども)', icon: 'mdi-school', link: '#lesson' },
        { titleKey: 'title_emergency_kit', fallback: '防災用品', icon: 'mdi-bag-personal', link: '#emergency_kit' },
        { titleKey: 'title_trip', fallback: '旅行・レジャー', icon: 'mdi-airplane', link: '#trip' },
        { titleKey: 'title_stock3', fallback: '株式 終値', icon: 'mdi-chart-line', link: '#stock3' }
      ],
      dialog: false,
      dialog_attention: false,
      communication: false,
      screenshot: false,
      error_message: '',
      phrase: {},
      personaCardHeight: null,
      topCardsObserver: null
    }
  },
  components: {
    personalSheet,
    personaCard,
    barchartCard,
    house,
    electricity,
    gas,
    water,
    food,
    fashion,
    car,
    smartphone,
    media,
    dailyNecessities,
    stock2,
    medical,
    saving,
    lifeInsurance,
    eatOut,
    lesson,
    emergencyKit,
    trip,
    stock3
  },
  methods: {
    submit() {
      if (this.dialog) return;
      this.dialog_attention = false;
      if (hasPersonalSheetErrors(validatePersonalSheet(this.$store.state))) {
        this.$refs.personalSheet.showValidationErrors();
        return;
      }
      this.dialog = true;
      this.communication = true;
      this.doSomething()
        .then(() => {
          const submitUrl = (this.$store.state.env === 'DEV') ? API_ENDPOINTS.DEV.submit : API_ENDPOINTS.PRD.submit;
          const summary = buildFinanceSummary(this.$store.state);
          const payload = {
            target: this.$store.state.target,
            env: this.$store.state.env,
            name: this.$store.state.login_response.queryStringParameters.name,
            account: this.$store.state.login_response.persona.account,
            pin: this.$store.state.login_response.persona.pin,
            nmi: this.$store.state.login_response.persona.net_monthly_income,
            lucky_card: this.$store.state.login_response.persona.lucky_card,
            is_married: this.$store.state.login_response.persona.is_married,
            people: this.$store.state.login_response.persona.people,
            people_electricity: this.$store.state.people_electricity,
            people_gas: this.$store.state.people_gas,
            people_water: this.$store.state.people_water,
            ...summary,
            ...personalSheetSubmission(this.$store.state)
          };

          axios.post(submitUrl, payload).then(response => {
            // handle success(axiosの処理が成功した場合に処理させたいことを記述)
            console.log('response', response);
            console.log('response.data', response.data);
            console.log('response.status', response.status);
            console.log('response.statusText', response.statusText);
            console.log('response.headers', response.headers);
            console.log('response.config', response.config);
            this.$store.commit('set_submitted_summary', summary);
            this.$router.push({ name:'Complete'});
            this.dialog = false;
          }).catch(error => {
            // handle error(axiosの処理にエラーが発生した場合に処理させたいことを記述)
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log('error.response.data', error.response.data);
              console.log('error.response.status', error.response.status);
              console.log('error.response.headers', error.response.headers);
              console.log('error.response.data.message', error.response.data.message);
              this.error_message = error.response.data.message;
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log('error.request', error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error(error.message)', error.message);
            }
            console.log('error.config', error.config);
          }).finally(() => {
            // always executed(axiosの処理結果によらずいつも実行させたい処理を記述)
            this.communication = false;
          });
        })
    },
    close_dialog() {
      this.dialog = false;
      this.error_message = '';
    },
    doSomething() {
      return new Promise((resolve) => {
        setTimeout(() => {
          console.log(`Submitted on ${new Date()}`);
          resolve();
        }, 1000);
      });
    },
    debug() {
    },
    enableScreenshot () {
      this.screenshot = false;
    },
    getWords: function () {
      this.phrase = words
    },
    isDesktopLayout() {
      if (this.$vuetify && this.$vuetify.breakpoint) {
        return this.$vuetify.breakpoint.mdAndUp
      }
      return window.innerWidth >= 960
    },
    syncTopCardsHeight() {
      this.$nextTick(() => {
        if (!this.isDesktopLayout()) {
          this.personaCardHeight = null
          return
        }

        const personaCol = this.$refs.personaTopCol
        const personaColEl = personaCol ? (personaCol.$el || personaCol) : null
        if (!personaColEl) return

        const personaCard = personaColEl.querySelector('#persona')
        if (!personaCard) return

        const nextHeight = Math.ceil(personaCard.getBoundingClientRect().height)
        if (nextHeight > 0 && this.personaCardHeight !== nextHeight) {
          this.personaCardHeight = nextHeight
        }
      })
    },
    setupTopCardsObserver() {
      const personaCol = this.$refs.personaTopCol
      const personaColEl = personaCol ? (personaCol.$el || personaCol) : null
      if (!personaColEl || this.topCardsObserver || typeof ResizeObserver === 'undefined') return

      const personaCard = personaColEl.querySelector('#persona')
      if (!personaCard) return

      this.topCardsObserver = new ResizeObserver(() => {
        this.syncTopCardsHeight()
      })
      this.topCardsObserver.observe(personaCard)
    }
    // ...mapActions (['getPosts'])
  },
  computed: {
    // ...mapState(['login_response']),
    nav_lists: function() {
      return this.nav_items.map((item) => {
        let name = item.fallback

        if (item.titleKey) {
          name = this.phrase[item.titleKey] || item.fallback
        } else if (item.titleKeys && item.titleKeys.length > 0) {
          const titles = item.titleKeys
            .map((key) => this.phrase[key])
            .filter(Boolean)
          name = titles.length > 0 ? titles.join('・') : item.fallback
        }

        return {
          name,
          icon: item.icon,
          link: item.link
        }
      })
    },
    calc_progress_per : function() {
      return Math.floor(this.$store.state.progress * 100 / this.$store.state.contents);
    }
  },
  mounted() {
    this.getWords()
    this.$store.dispatch('getPosts')

    window.history.pushState(null, null, null);
    window.addEventListener("popstate", function() {
      window.history.pushState(null, null, null);
      return;
    });

    this.syncTopCardsHeight()
    this.setupTopCardsObserver()
    window.addEventListener('resize', this.syncTopCardsHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.syncTopCardsHeight)
    if (this.topCardsObserver) {
      this.topCardsObserver.disconnect()
      this.topCardsObserver = null
    }
  }
}

</script>
